<div class="container">
  <ul>
    <li>
      <hyperkit-breadcrumb
        routerLink="/research"
        text="Research"
        [selected]="false"
        [inactive]="false"
        [clickable]="true"
      ></hyperkit-breadcrumb>
    </li>
    @if (searchLink | async; as search) {
      <li class="search-term">
        <hyperkit-icon
          color="primary"
          size="base"
          icon="chevron-right"
          aria-hidden="true"
        ></hyperkit-icon>
        <hyperkit-breadcrumb
          [routerLink]="search.routerLink"
          [queryParams]="search.queryParams"
          text="Search"
          [selected]="!sub"
          [inactive]="false"
          [clickable]="true"
        ></hyperkit-breadcrumb>
      </li>
    }
    @if (sub) {
      <li class="sub">
        <hyperkit-icon
          color="primary"
          size="base"
          icon="chevron-right"
          aria-hidden="true"
        ></hyperkit-icon>
        <hyperkit-breadcrumb
          [routerLink]="sub.url"
          [text]="sub.type + ' ' + sub.title"
          [link]="sub.url"
          [selected]="!subSub"
          [inactive]="false"
          [clickable]="true"
        ></hyperkit-breadcrumb>
      </li>
    }
    @if (subSub) {
      <li class="sub">
        <i class="k-icon k-font-icon k-i-arrow-chevron-right"></i>
        <hyperkit-breadcrumb
          [routerLink]="subSub.url"
          [text]="subSub.type + ' ' + subSub.title"
          [link]="subSub.url"
          [selected]="true"
          [inactive]="false"
          [clickable]="true"
        ></hyperkit-breadcrumb>
      </li>
    }
  </ul>
</div>
